<template>
<div
    v-if="item != null"
    :class="{'meda-asset-card-container': true, 'selectable-container': select }"
    v-on:click="onClick"
>
    <img
        :src="item.image_url"
        style="max-width: 250px; max-height: 250px;"
        :class="{ 'archived': item.archived }"
    />
    <br/>

    <img 
        src="@/assets/outshinery-logo.png" 
        height="20"
        v-if="item.created_by_content_type='outshinery'"
        style="margin-bottom: 5px"
        :class="{ 'archived': item.archived }"
    />
    <br/>

    <span :class="{ 'archived': item.archived }">
        {{item.label}}
    </span>
    <br/>

   

     <div
        style="position: absolute; top: 5px; right: 5px"
     >
         <v-simple-checkbox
            v-if="select"
            label="Selected"
            :ripple="false"
            :value="selected"
            v-on:click="onClick"
        />

        <v-menu 
            bottom 
            offset-y  
            v-else
        >
        
        <template v-slot:activator="{ on }">
                
            <v-icon 
                v-on="on"
            >
                mdi-dots-vertical
            </v-icon>
                
        </template>
        
        <v-list>
            <v-list-item
                v-on:click="$emit('edit', item.asset_id)"
            >
                <v-list-item-title>Edit...</v-list-item-title>
            </v-list-item>

            <v-list-item
                v-on:click="onEditLabel()"
            >
                <v-list-item-title>Edit label...</v-list-item-title>
            </v-list-item>

            <v-divider/>

            <v-list-item
                v-on:click="onClickToggleArchive()"
            >
                <v-list-item-title>{{item.archived ? 'Unarchive' : 'Archive'}}</v-list-item-title>
            </v-list-item>

            <v-list-item
                v-on:click="onDelete()"
            >
                <v-list-item-title>Delete...</v-list-item-title>
            </v-list-item>
        
        </v-list>
        
        </v-menu> 
     </div>
    
</div>
</template>

<script>
const _ = require('lodash');

export default {
    props: {
        item: {
            type: Object,
            default: function() { return null; }
        },

        select: {
            type: Boolean,
            default: function() { return false; }
        },

        selected: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    methods: {
        onClickToggleArchive() 
        {
            let new_item = _.cloneDeep(this.item);
            new_item.archived = !new_item.archived;

            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/media-assets',
            
                'params' : new_item,
            
                'on_success': (data) => {
                        this.$emit('update');
                    },
            
                'on_error': 'Unable to save changes media asset',
            });
        },

        onClick()
        {
            this.$emit('select', !this.selected);
        },

        onEditLabel()
        {
             this.$rc.prompt({
                'title' : 'Edit Label',
                'label' : 'Label',
                'value' : this.item.label,
                'after_prompt' : (value) => {
                    let new_item = _.cloneDeep(this.item);
                    new_item.label = value;
                    this.$emit('input', new_item);
                }
            });
        },

        onDelete()
        {
            this.$rc.confirm({
                'title': 'Confirm delte?',
                'body': 'Are you certain that you want to permenantly delete the media asset: '+this.item.label+"?",
                'btn_text_ok': 'Delete',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.$emit('delete',this.item);
                },
            });
        },
    },
}
</script>

<style lang="scss" scoped>

.meda-asset-card-container
{
    border: 1px solid rgba(0,0,0,0.2); 
    border-radius: 15px; 
    float: left; 
    margin-left: 15px; 
    margin-right: 15px; 
    margin-bottom: 15px; 
    margin-top: 15px; 
    text-align: center; 
    padding: 15px; 
    position: relative;
    min-width: 320px;
    min-height: 320px;
}

.selectable-container
{
    cursor: pointer;
}

.selectable-container:hover
{
    border: 1px solid rgba(0,0,255,0.2); 
}

.archived
{
    opacity: 0.4;
}

</style>
